var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { useTranslation } from 'react-i18next';
var UnsavedChangesDialog = function (_a) {
    var open = _a.open, onConfirm = _a.onConfirm, onCancel = _a.onCancel, _b = _a.confirmText, confirmText = _b === void 0 ? 'Leave Without Saving' : _b, _c = _a.cancelText, cancelText = _c === void 0 ? 'Stay on Page' : _c, _d = _a.message, message = _d === void 0 ? 'You have unsaved changes. Are you sure you want to leave? Your changes will be lost.' : _d;
    var t = useTranslation().t;
    var stayButtonRef = React.useRef(null);
    return (_jsxs(Dialog, __assign({ open: open, onClose: onCancel, TransitionProps: { onEntered: function () { var _a; return (_a = stayButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus(); } }, "aria-labelledby": "unsaved-changes-dialog-title", "aria-describedby": "unsaved-changes-dialog-description" }, { children: [_jsxs(DialogTitle, __assign({ id: "unsaved-changes-dialog-title", sx: { display: 'flex', alignItems: 'center', gap: 1 } }, { children: [_jsx(WarningIcon, { color: "warning" }), t('Unsaved Changes')] })), _jsx(DialogContent, { children: _jsx(DialogContentText, __assign({ id: "unsaved-changes-dialog-description" }, { children: t(message, { defaultValue: message }) })) }), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ ref: stayButtonRef, onClick: onCancel, color: "primary", variant: "outlined", sx: {
                            '&:focus': {
                                outline: '2px solid',
                                outlineColor: 'primary.dark',
                                outlineOffset: 2
                            }
                        } }, { children: t(cancelText) })), _jsx(Button, __assign({ onClick: onConfirm, color: "error", variant: "contained", sx: {
                            '&:focus': {
                                outline: '2px solid',
                                outlineColor: 'error.dark',
                                outlineOffset: 2
                            }
                        } }, { children: t(confirmText) }))] })] })));
};
export default UnsavedChangesDialog;
